module.exports = __webpack_public_path__ + "static/media/abogadosasociados.e9a16277.png";